export default __webpack_public_path__ + "static/3-3eb9d2fab3951e051fe82e199a9f7fff.webp";